import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewTransactionComp  from "./Component/ViewTransactionComp"

const ViewTransaction =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewTransactionComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewTransaction